export type PaddingOptions = { top: number, left: number, right: number, bottom: number };
export type LoveOptions = { isLoved: boolean };
export type ZoomOptions = { preventZoom?: boolean, zoom?: number, minZoom?: number, padding?: PaddingOptions };
export type FeatureOptions = { featureId: number };
export type MediaOptions = { mediaKey: string, consumedPct?: number };
export type PointOptions = { challengeKey: string, points: number, bonusPoints: number, isCorrectAnswer: boolean };
export type VoucherOptions = { voucherKey: string, productKey: string };
export type UnlockOptions = { preventViewChange?: boolean, force?: boolean };
export type NavigateOptions = { preventOpenStoryModal?: boolean, skipLocationChange?: boolean };

export type MoteEventOptions = LoveOptions | ZoomOptions | FeatureOptions | MediaOptions | PointOptions | VoucherOptions | UnlockOptions | NavigateOptions;

/**
 * Mote event type
 */
export enum MoteEventType {
    MAP_MOTE_SELECTED = "MAP_MOTE_SELECTED",
    MAP_MOTE_UNSELECTED = "MAP_MOTE_UNSELECTED",
    MAP_FEATURE_SELECTED = "MAP_FEATURE_SELECTED",
    MAP_FEATURE_UNSELECTED = "MAP_FEATURE_UNSELECTED",
    START_TOUR = "START_TOUR",
    INACTIVE_SELECTED = "INACTIVE_SELECTED",
    SWIPER_MOTE_FOCUS = "SWIPER_MOTE_FOCUS",
    SWIPER_OPENED = "SWIPER_OPENED",
    SWIPER_CLOSED = "SWIPER_CLOSED",
    SWIPER_MOTES_UPDATED = "SWIPER_MOTES_UPDATED",
    SELECTED_SWIPER_MOTE_CLICKED = "SELECTED_SWIPER_MOTE_CLICKED",
    SHOW_FEATURE_ON_MAP = "SHOW_FEATURE_ON_MAP",
    HIDE_FEATURE_ON_MAP = "HIDE_FEATURE_ON_MAP",
    SHOW_3D_MOTE_ON_MAP = "SHOW_3D_MOTE_ON_MAP",
    ZOOM_TO_3D_MOTE_DONE = "ZOOM_TO_3D_MOTE_DONE",
    HIDE_3D_MOTE_ON_MAP = "HIDE_3D_MOTE_ON_MAP",
    SELECT_ACTIVE_ROUTE = "SELECT_ACTIVE_ROUTE",
    SHOW_MAP_MARKER = "SHOW_MAP_MARKER",
    HIDE_MAP_MARKER = "HIDE_MAP_MARKER",
    OPEN_UNLOCKED_MOTE = "OPEN_UNLOCKED_MOTE",
    OPEN_SCHEDULE_MOTE = "OPEN_SCHEDULE_MOTE",
    LOVE_CHANGED = "LOVE_CHANGED",
    UNLOCK_MOTE = "UNLOCK_MOTE",
    UNLOCK_STARTED = "UNLOCK_STARTED",
    UNLOCK_DONE = "UNLOCK_DONE",
    SKIP_TO_MOTE = "SKIP_TO_MOTE",           // Open swiper only after swipe has finished
    SWIPE_TO_MOTE = "SWIPE_TO_MOTE",         // Swipe to mote in swiper (dont change tap view)
    SHOW_MOTE_ON_MAP = "SHOW_MOTE_ON_MAP",      // Show mote on map, without opening swiper (show map tap view)
    FLY_TO_TOUR = "FLY_TO_TOUR",
    AUTOSELECT_MOTE_ON_MAP = "AUTOSELECT_MOTE_ON_MAP",// Show mote on map, without opening swiper (dont change map tap view)
    NAVIGATE_TO_MOTE = "NAVIGATE_TO_MOTE",       // Show mote on map and open directions bar (show map tap view)
    SHOW_MOTE_MEDIA = "SHOW_MOTE_MEDIA",
    MEDIA_CONSUMED = "MEDIA_CONSUMED",
    QUIZ_PRELOAD = "QUIZ_PRELOAD",
    QUIZ_REQUESTED = "QUIZ_REQUESTED",
    QUIZ_STARTED = "QUIZ_STARTED",
    QUIZ_POINT = "QUIZ_POINT",
    QUIZ_SKIP_REQUESTED = "QUIZ_SKIP_REQUESTED",
    QUIZ_SKIPPED = "QUIZ_SKIPPED",
    QUIZ_COMPLETED = "QUIZ_COMPLETED",
    QUIZ_SCOREBOARD_CLOSED = "QUIZ_SCOREBOARD_CLOSED",
    SHOW_TOURS = "SHOW_TOURS",
    SHOW_CHALLENGES = "SHOW_CHALLENGES",
    SHOW_MAP = 'SHOW_MAP',
    VOUCHER_CLAIMED = "VOUCHER_CLAIMED",
    MOTE_FILTER_UPDATED = "MOTE_FILTER_UPDATED",
    GROUP_START_TOUR = 'GROUP_START_TOUR',
    GROUP_UNLOCK_MOTE = 'GROUP_UNLOCK_MOTE',
    GROUP_PREVENT_REQUEST = "GROUP_PREVENT_REQUEST", // Emit when a user requests playback or quiz but the other members aren't IDLE
    INTROFLOW_CLOSED = "INTROFLOW_CLOSED"
}

export interface MoteEventSerializable {
    type: MoteEventType;
    moteKey?: string;
    options?: MoteEventOptions;
}

export type MediaEventMap = { [sec: string]: MoteEventSerializable };
